'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu');
  const menuBtnOpen = document.querySelector('.header__burger');
  const menuBtnClose = document.querySelector('.menu__close');

  menuBtnOpen.addEventListener('click', () => {
    menu.classList.add('menu__active');
    document.body.classList.add('no-scroll');
  });

  menuBtnClose.addEventListener('click', () => {
    menu.classList.remove('menu__active');
  });

  menu.addEventListener('click', (e) => {
    if(e.offsetX < 0) {
      menu.classList.remove('menu__active');
    }
  });

  window.addEventListener('keydown', (e) => {
    if(e.code === 'Escape' && menu.closest('.menu__active')) {
      menu.classList.remove('menu__active');
    }
  });

  menu.addEventListener('transitionend', (e) => {
    if(!menu.closest('.menu__active') && e.propertyName === 'transform') {
      document.body.classList.remove('no-scroll');
    }
  });

  // submenu
  const arrowToSubmenu = document.querySelectorAll('.menu__arrow');
  arrowToSubmenu.forEach((item) => {
    item.addEventListener('click', (e) => {
      if(document.body.clientWidth < 992) {
        e.target.nextElementSibling.classList.add('opened');
      }
    })
  });

  const arrowPrev = document.querySelectorAll('.menu__button');
  arrowPrev.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.target.parentElement.classList.remove('opened');
    })
  });
});